import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Button,
  FormText,
} from "reactstrap";

import {connect} from 'react-redux'
import {addMachine} from '../../store/actions/machineActions'

class AddMachine extends Component {
  state = {
    UHANo: "",
    typeIdentity: "",
    model: "",
    name: "",
    unit: "No Unit"
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleReset = (e) =>{
    this.setState({
      UHANo: "",
      typeIdentity: "",
      model: "",
      name: "",
      unit: "No Unit"
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    // console.log(this.state);
    this.props.addMachine(this.state)
    this.setState({
      UHANo: "",
      typeIdentity: "",
      model: "",
      name: "",
      unit: "No Unit"
    })
  };

  render() {
    return (
      <div>
              <Card>
                <CardBody>
                  <CardTitle>
                    <h5 className="text-center">Machine Details</h5>
                  </CardTitle>
                  <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                    <FormText>UHA No</FormText>
                      <Input
                        required
                        type="text"
                        name="UHANo"
                        id="UHANo"
                        placeholder="20845"
                        onChange={this.handleChange}
                        value={this.state.UHANo}
                      />
                    </FormGroup>

                    <FormGroup>
                    <FormText>Type Identity</FormText>
                      <Input
                        required
                        type="text"
                        name="typeIdentity"
                        id="typeIdentity"
                        placeholder="AWBL 30XX"
                        onChange={this.handleChange}
                        value={this.state.typeIdentity}
                      />
                    </FormGroup>
               
                    <FormGroup>
                    <FormText>Model</FormText>
                      <Input
                        required
                        type="text"
                        name="model"
                        id="model"
                        placeholder="JCB 3DX"
                        onChange={this.handleChange}
                        value={this.state.model}
                      />
                    </FormGroup>

                    <FormGroup>
                    <FormText>Machine</FormText>
                      <Input
                        required
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Dozer"
                        onChange={this.handleChange}
                        value={this.state.name}
                      />
                    </FormGroup>

                    <FormGroup>
                    <FormText>Unit</FormText>
                      <Input required type="select" name="unit" id="unit" onChange={this.handleChange}>
                        <option value="No Unit">Select</option>
                        <option value="1 SLE">1 SLE</option>
                        <option value="2 SLE">2 SLE</option>
                        <option value="3 SLE">3 SLE</option>
                        <option value="4 SLE">4 SLE</option>
                        <option value="5 SLE">5 SLE</option>
                        <option value="6 SLE">6 SLE</option>
                        <option value="7 SLE">7 SLE</option>
                        <option value="8 SLE">8 SLE</option>
                        <option value="9 SLE">9 SLE</option>
                        <option value="10 SLE">10 SLE</option>
                        <option value="11 SLE">11 SLE</option>
                        <option value="12 SLE">12 SLE</option>
                        <option value="SLSME">SLSME</option>
                        <option value="WKSP">WKSP</option>
                      </Input>
                    </FormGroup>

                    <FormGroup className="d-flex justify-content-between">
                      <Button type="reset" onClick={this.handleReset} color="warning"  outline >
                        Cancel
                      </Button>
                      <Button color="primary" className="ml-5" block>
                        Add Now
                      </Button>
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    addMachine: (machine) => dispatch(addMachine(machine))
  }
}

export default  connect(null, mapDispatchToProps)(AddMachine);
